import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import ReportService from '../../service/report-service';

import FileSaver from 'file-saver';

import { Spinner } from 'react-bootstrap';
import { ModalAlert } from '../template/modal-alert';
import i18n from "../../i18n";
import { Trans } from 'react-i18next';
import ActivityService from '../../service/activity-service'

export default class Instructions extends Component {

    constructor(props) {
        super(props);
        this.state = {
            downloading: false,
        };
        this.handleDownload = this.handleDownload.bind(this);

    }

    handleDownload() {
        let self = this;
        self.setState({
            downloading: true
        })
        ReportService.getPdfInstructions(this.props.language).then(response => {
            if (response.data.error != null) {
                ModalAlert(error.response.data.error.errorMsg, i18n.t("modal:greska"), i18n.t("modal:zatvori"));
            } else {
				/* console.log(response.data.reportName);
				console.log(response.data.pdf); */

                var binaryString = window.atob(response.data.pdf);
                var binaryLen = binaryString.length;
                var bytes = new Uint8Array(binaryLen);
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i);
                    bytes[i] = ascii;
                }
                var newBlob = new Blob([bytes], { type: "application/pdf" });

                FileSaver.saveAs(newBlob, response.data.reportName);
                self.setState({
                    downloading: false
                });
            }

        }).catch(error => {
            ModalAlert(error.response.data.error.errorMsg, i18n.t("modal:greska"), i18n.t("modal:zatvori"));
            self.setState({
                downloading: false
            });
        });

    }

    render() {
        return (
            <React.Fragment>
                <div className="row justify-content-center">
                    {this.state.downloading ?
                        <Spinner animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                        :
                        <button onClick={() => this.handleDownload()} style={{ "textAlign": "center", "border": "none", "backgroundColor": "transparent" }}>
                            <i className="material-icons align-middle" aria-hidden="true">file_download</i>
                            <p>{i18n.t("home:download_instructions")}</p>
                        </button>
                    }
                </div>
                {/* <div className="row justify-content-center">
                    <p>{i18n.t("home:download_instructions")}</p>
                </div> */}

            </React.Fragment>
        );
    }
}